import React, { useState, useEffect } from "react";
import ME from "../../assets/me2.jpg";
import CTA from "./CTA";
import "./header.css";
import HeaderSocials from "./HeaderSocials";

const Header = () => {
  const titles = ["Henry Tran"];
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex(index !== titles.length - 1 ? index : index);
      console.log(index);
    }, 4000);

    return () => clearInterval(interval);
  }, [index]);

  return (
    <header id="home">
      <div className="container header__container">
        <div className="greet-container">
          <span className="text first-text">Hi, </span>
          <span className="text first-text">I'm </span>
          <span className="text sec-text -z-50">{titles[index]}</span>
        </div>

        <div>
          <h2 className="text-xl pb-2 text-transparent bg-clip-text bg-gradient-to-r to-emerald-600 from-sky-400">Aspiring Developer</h2>
          <h2 className="text-sm">Computer Science Undergraduate </h2>
          <h2 className="text-sm">at University of Maryland, College Park</h2>
        </div>

        <CTA />
        <HeaderSocials />
        <div className="me">
          <img src={ME} alt="Me" className="me-img" />
        </div>
        {/* <div className="title-container">
          <div className="title">Developer</div>
        </div> */}

        <a href="#contact" className="scroll__down">
          Scroll Down
        </a>
      </div>
    </header>
  );
};

export default Header;
